const getterTypes = {
};

const actionTypes = {
  INIT_DASHBOARD_HOME_DATA: 'INIT_DASHBOARD_HOME_DATA'
};

const mutationTypes = {
  DASHBOARD_HOME_DATA_CHANGED: 'DASHBOARD_HOME_DATA_CHANGED',

  CURRENT_TAB_CHANGED: 'CURRENT_TAB_CHANGED',
  SHOW_PHONE_MENU_CHANGED: 'SHOW_PHONE_MENU_CHANGED',
  IS_USER_GUIDE_CHANGED: 'IS_USER_GUIDE_CHANGED',
  IS_CUSTOM_POPUP_CHANGED: 'IS_CUSTOM_POPUP_CHANGED',
  IS_POPUP_STEP_CHANGED: 'IS_POPUP_STEP_CHANGED',
  IS_BUTTON_SOURCE_CHANGED: 'IS_BUTTON_SOURCE_CHANGED',
  SHOW_LOANS_POPUP: 'SHOW_LOANS_POPUP',
  TIME_OUT: 'TIME_OUT',
};

const types = {
  ...getterTypes,
  ...actionTypes,
  ...mutationTypes,
};

const getterProxy = typeof Proxy === 'undefined' ? getterTypes : new Proxy(getterTypes, {
  get(target, key, receiver) {
    const value = Reflect.get(target, key, receiver);
    if (!value) {
      throw new Error(`undefined getter key detected ${key}`);
    }

    return value;
  }
});

const actionProxy = typeof Proxy === 'undefined' ? actionTypes : new Proxy(actionTypes, {
  get(target, key, receiver) {
    const value = Reflect.get(target, key, receiver);
    if (!value) {
      throw new Error(`undefined action key detected ${key}`);
    }

    return value;
  }
});

const mutationProxy = typeof Proxy === 'undefined' ? mutationTypes : new Proxy(mutationTypes, {
  get(target, key, receiver) {
    const value = Reflect.get(target, key, receiver);
    if (!value) {
      throw new Error(`undefined mutation key detected ${key}`);
    }

    return value;
  }
});

const proxy = typeof Proxy === 'undefined' ? types : new Proxy(types, {
  get(target, key, receiver) {
    const value = Reflect.get(target, key, receiver);
    if (!value) {
      throw new Error(`undefined type key detected ${key}`);
    }

    return value;
  }
});

export default proxy;
export { getterProxy as getterTypes, actionProxy as actionTypes, mutationProxy as mutationTypes };



// WEBPACK FOOTER //
// ./src/vuex/types.js